

const styles = {
    toggleBtn: {
        color: '#000',
    },
    features: {
        height: '30vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: '25px',
        width: '100%',
    },
    homePara: {
        color: 'gray', fontSize: '20px', letterSpacing: '1px'
    },
    choose: {
        fontSize: '35px', textTransform: 'uppercase', letterSpacing: '1px',
    },
    aboutLayout: {
        height: '70vh', marginBottom: '20px',
    },
    aboutUs: {
        display: 'flex', alignItems: 'center',
    },
    aboutusDiv: {
        backgroundColor: 'none', width: '100%', height: '50vh', margin: '50px 0', 
        padding: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center'
    },
    ourTeamDiv: {
        height: '20vh', display: 'flex', justifyContent: 'center', alignItems: 'center'
    },
    label: {
        display: "block", fontSize: '18px', color: "#333", margin: "10px 0px"
    },
    mesInput: {
        border: "1px solid gray", borderRadius: "20px", width: "100%", fontSize: "16px"
    },
    mesTextArea: {
        border: "1px solid gray", borderRadius: "20px", padding: "5px 10px", fontSize: "16px", marginBottom: "10px", width: "100%"
    }
}

export default styles;